var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('show-reservation',{attrs:{"data":_vm.data,"date":_vm.data.date,"type":'show'},on:{"Cancel":function($event){return _vm.$router.back()},"close":function($event){return _vm.$router.back()},"Reminder":_vm.reminder,"Back":function($event){return _vm.$router.back()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }